import type { SortingState } from "@tanstack/react-table";

import type { SortDirection, SortingApi } from "./sortingToApi.types";

export const SORT_DIRECTION = { ASC: "up", DESC: "down" } as const;

export function toSortDirection(desc: boolean): SortDirection {
  return desc ? SORT_DIRECTION.DESC : SORT_DIRECTION.ASC;
}

export function sortingToApi(sorting: SortingState): SortingApi | undefined {
  const [firstSort] = sorting;

  if (!firstSort) return undefined;

  return { field: firstSort.id, direction: toSortDirection(firstSort.desc) };
}
